import styled, {css} from 'styled-components'
import {TableBodyCell, TableBodyCellText} from '@components/ui/table-atoms/TableAtoms.tsx'

export const StyledWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral['white']};
        height: 100%;
        border-radius: 8px 8px 0 0;
        border: 1px solid ${palette.neutral[200]};
    `
)

export const StyledSelectCell = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: ${spacing * 2}px;
        width: 100%;
        padding: ${spacing * 0.5}px;
    `
)

export const StyledStatusCell = styled(TableBodyCellText)(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        width: 100%;
        & > svg {
            fill: ${palette.success[500]};
        }
    `
)

export const StyledReferringDoctorCell = styled(TableBodyCell)(
    ({theme: {typography}}) => css`
        display: flex;
        align-items: flex-start !important;
        justify-content: center;
        flex-direction: column;
        & > p:last-child {
            ${typography.textXs}
        }
    `
)

export const StyledProgressCell = styled(TableBodyCellText)(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing}px;
        width: 100%;
    `
)
